import React from "react";

const EmptyTasksState = ({ showCompleted }) => {
  return (
    <div className="no-tasks-message">
      {showCompleted ? (
        <p>No tasks found, adjust your filters.</p>
      ) : (
        <h4>No tasks. Add a new task above!</h4>
      )}
    </div>
  );
};

export default EmptyTasksState;
